import { axiosInstance } from ".";

const getOwners = async (params) =>
  await axiosInstance.get("/owners", { params });

const getDrivers = async (params) =>
  await axiosInstance.get("/drivers", { params });

const getOwnerDetails = async (id) => await axiosInstance.get(`/owners/${id}`);

const getDriverDetails = async (id) =>
  await axiosInstance.get(`/drivers/${id}`);

const getTeamDrivers = async ({ id, params }) =>
  await axiosInstance.get(`/owners/${id}/drivers`, { params });

const getDriverPoints = async (params) =>
  await axiosInstance.get(`/points_details`, { params });

const getDriverRewards = async (params) =>
  await axiosInstance.get(`/driver_rewards`, { params });

const editDriver = async ({ id, data }) =>
  await axiosInstance.patch(`/drivers/${id}`, data);

const bulkEditDrivers = async (data) =>
  await axiosInstance.patch(`/drivers/toggle_qualification`, data);

const qualifyDriverByPhoneNumber = async (data) =>
  await axiosInstance.post(`/drivers/qualify_by_phone_number`, data);

const qualifyDriversBySheet = async ({ formData }) =>
  await axiosInstance.post(`/drivers/qualify_from_sheet`, formData);

const getPendingDrivers = async (params) =>
  await axiosInstance.get("/manually_imported_drivers", { params });

const editPendingDriver = async ({ id, data }) =>
  await axiosInstance.patch(`/manually_imported_drivers/${id}`, data);

const getDriverRequests = async (params) =>
  await axiosInstance.get("/verification_requests", {
    params,
  });

const updateDriverRequest = async ({ id, data }) =>
  await axiosInstance.patch(`/verification_requests/${id}`, data);

const getReferralRewardsRequests = async (params) =>
  await axiosInstance.get("/referrals", { params });

const verifyDriverLicense = async (data) =>
  await axiosInstance.post(`/drivers/validate_license_number`, data);

const getVehicles = async ({ id, params }) =>
  await axiosInstance.get(`/owners/${id}/vehicles`, { params });

const flagUserAsFraud = async ({ id, data }) =>
  await axiosInstance.patch(`/users/${id}/flag`, data);

export {
  getOwners,
  getDrivers,
  getOwnerDetails,
  getDriverDetails,
  getTeamDrivers,
  getDriverPoints,
  getDriverRewards,
  editDriver,
  bulkEditDrivers,
  qualifyDriverByPhoneNumber,
  qualifyDriversBySheet,
  getPendingDrivers,
  editPendingDriver,
  getDriverRequests,
  updateDriverRequest,
  getReferralRewardsRequests,
  verifyDriverLicense,
  getVehicles,
  flagUserAsFraud,
};
